import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { styles } from "../styles/styles";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PeopleIcon from "@mui/icons-material/People";
import FavoriteIcon from "@mui/icons-material/Favorite";

function OfferSection() {
	return (
		
		<Grid container spacing={0} justifyContent="center">
		<Grid item xs={12} sm={6} md={3} sx={{ display: "flex", justifyContent: "center" }}>
		  <Box sx={{ ...styles.statsCard,}}>
			<PeopleIcon sx={styles.statsIcon} />
			<Typography sx={styles.statsText}>
			  <Typography sx={styles.statsNumber}>100%</Typography>
			  Mobile-verified Profiles
			</Typography>
		  </Box>
		</Grid>
	  
		<Grid item xs={12} sm={6} md={4} sx={{ display: "flex", justifyContent: "center" }}>
		  <Box sx={{ ...styles.statsCard,}}>
			<VerifiedUserIcon sx={styles.statsIcon} />
			<Typography sx={styles.statsText}>
			  <Typography sx={styles.statsNumber}>4 Crores +</Typography>
			  Customers served
			</Typography>
		  </Box>
		</Grid>
	  
		<Grid item xs={12} sm={6} md={4} sx={{ display: "flex", justifyContent: "center" }}>
		  <Box sx={{ ...styles.statsCard,}}>
			<FavoriteIcon sx={styles.statsIcon} />
			<Typography sx={styles.statsText}>
			  <Typography sx={styles.statsNumber}>21 Years</Typography>
			  Successful Matching
			</Typography>
		  </Box>
		</Grid>
	  </Grid>
	  
	);
}

export default OfferSection;
